const getCookieValue = (name) => {
    if (typeof document === 'undefined') {
        return undefined;
    }

    const match = document.cookie
        .split(';')
        .map((c) => c.trim())
        .find((c) => c.startsWith(`${name}=`));

    return match ? decodeURIComponent(match.split('=').slice(1).join('=')) : undefined;
};

const getCookie = () => {
    if (typeof window !== 'undefined' && window.__NOWSESSIONID) {
        return window.__NOWSESSIONID;
    }

    const cookieSession = getCookieValue('NOWSESSIONID');
    if (cookieSession) return cookieSession;


    return undefined;
};

export default getCookie;